import { useEffect, useState } from "react";
import axios from "../../api/axiosConfig";
import QPointsModal from "../../components/modals/QPointsModal";
import { toast } from "react-toastify";

export default function QPointsManager() {
  const [configs, setConfigs] = useState([]);
  const [open, setOpen] = useState(false);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get("/qpoints").then((res) => setConfigs(res.data?.data?.config ?? res.data?.data ?? []));
  }, []);

  const handleChange = (id, points) => {
    setConfigs((prev) =>
      prev.map((c) => (c.id === id ? { ...c, points } : c)),
    );
  };

  const handleSave = async () => {
    setLoading(true);

    try {
      await Promise.all(
        configs.map((c) =>
          axios.put(`/qpoints/config`, {
            action: c.action,
            points: c.points,
            active: c.active,
          }),
        ),
      );

      toast.success("QPUNTOS actualizados correctamente");
      setOpen(false);
    } catch (error) {
      console.error(error);

      toast.error(
        error?.response?.data?.message ||
          "Error al actualizar la configuración de QPUNTOS",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-bold text-gray-800">
        Sistema de recompensas
      </h3>

      <div className="bg-white p-5 rounded-2xl shadow flex items-center justify-between">
        <div>
          <p className="font-semibold">QPUNTOS</p>
          <p className="text-sm text-gray-600">
            Configura puntos por registro, compras y referidos
          </p>
        </div>

        <button
          onClick={() => setOpen(true)}
          className="px-4 py-2 rounded-xl bg-supernova-500 text-white hover:bg-supernova-600"
        >
          Configurar
        </button>
      </div>

      <QPointsModal
        open={open}
        onClose={() => setOpen(false)}
        configs={configs}
        onChange={handleChange}
        onSave={handleSave}
      />
    </div>
  );
}
